import {AbstractStorage} from "./AbsctractStorage";

export class LocalStorage extends AbstractStorage {
    set(key, value) {
        if(value !== undefined && value !== null) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }
    get(key) {
        if(localStorage.getItem(key) !== undefined && localStorage.getItem(key) !== null && localStorage.getItem(key) !== {}) {
            return JSON.parse(localStorage.getItem(key));
        }
        return undefined;
    }
    remove(key) {
        localStorage.removeItem(key);
    }
    clear() {
        localStorage.clear();
    }
}


// WEBPACK FOOTER //
// ./src/storage/LocalStorage.js